import React, { useEffect, useState } from "react";
import { StoryElement } from "@quintype/components";
import { object, string } from "prop-types";
import { WithStoryAds } from "../../WithStoryAds";
import { isTemplateWithAds, extractElements } from "../../../utils/story";
import { TEMPLATES_WITH_PARAGRAPH_ADS } from "../../../../constants";

import "./text-element.m.css";

const CustomParagraph = ({ paragraph, story, counter }) => {
  const componentToRender = <div styleName="custom-paragraph" dangerouslySetInnerHTML={{ __html: paragraph }} />;
  const enableParagraphAds = isTemplateWithAds(story);

  return enableParagraphAds ? (
    <WithStoryAds counter={counter} componentToRender={componentToRender} story={story} />
  ) : (
    <>{componentToRender}</>
  );
};

CustomParagraph.propTypes = {
  paragraph: string,
  story: object,
  counter: object,
};

export const CustomTextElement = ({ element, story, counter = {} }) => {
  const elements = extractElements(element.text);
  const isParagraphTemplate = TEMPLATES_WITH_PARAGRAPH_ADS.includes(story?.["story-template"]);
  if (isParagraphTemplate) {
    return (
      <div className="story-element story-element-text">
        {elements?.map((ele, index) => {
          if (ele.tagName === "p") {
            return <CustomParagraph key={index} story={story} counter={counter} paragraph={ele.text} />;
          } else {
            return <div key={index} dangerouslySetInnerHTML={{ __html: ele.text }} />;
          }
        })}
      </div>
    );
  }

  const componentToRender = (
    <div styleName="custom-text">
      <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
    </div>
  );
  const enableParagraphAds = isTemplateWithAds(story);

  return enableParagraphAds ? (
    <WithStoryAds counter={counter} componentToRender={componentToRender} story={story} />
  ) : (
    <>{componentToRender}</>
  );
};

CustomTextElement.propTypes = {
  element: object,
  story: object,
  counter: object,
};
